import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import SidebarChannel from "./SidebarChannel";
import SignalCellularAltIcon from "@material-ui/icons/SignalCellularAlt";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CallIcon from "@material-ui/icons/Call";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Avatar } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectUser } from "../../features/userSlice";
import { auth } from "../../firebase";
import axios from "../../axios";
import Pusher from "pusher-js";

const pusher = new Pusher("f1bd3672103b6b62b557", {
  cluster: "ap2",
});

function Sidebar() {
  const user = useSelector(selectUser);

  const dispatch = useDispatch();

  const [channels, setChannels] = useState([]);
  const [channelInput, setChannelInput] = useState("");
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setChannelInput("");
  };

  const getChannels = () => {
    axios.get("/get/channelList").then((res) => {
      setChannels(res.data);
    });
  };

  const signOut = (demo) => {
    if (demo) {
      dispatch(logout());
    } else {
      auth.signOut();
    }
  };

  useEffect(() => {
    getChannels();

    const channel = pusher.subscribe("channels");
    channel.bind("newChannel", function (data) {
      getChannels();
    });
  }, []);

  const handleAddChannel = (e) => {
    e.preventDefault();

    if (channelInput) {
      axios.post("/new/channel", {
        channelName: channelInput,
      });
    }
    handleClose();
    setChannelInput("");
  };

  return (
    <div className="sidebar">
      <div className="sidebar__top">
        <h3>Channel Name</h3>
        <ExpandMoreIcon />
      </div>

      <div className="sidebar__channels">
        <div className="sidebar__channelsHeader">
          <div className="sidebar__header">
            <ExpandMoreIcon />
            <h4>Text Channels</h4>
          </div>
          <AddIcon onClick={handleClickOpen} className="sidebar__addChannel" />
        </div>

        <div className="sidebar__channelList">
          {channels.map((channel) => (
            <SidebarChannel
              key={channel.id}
              id={channel.id}
              channel={channel.name}
            />
          ))}
        </div>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"xs"}
        fullWidth={"xs"}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Create A New Channel</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            placeholder="Enter A Channel Name"
            type="text"
            value={channelInput}
            onChange={(e) => setChannelInput(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddChannel} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <div className="sidebar__voice">
        <SignalCellularAltIcon
          className="sidebar__voiceIcon"
          fontSize="large"
        />

        <div className="sidebar__voiceInfo">
          <h3>Voice Connected</h3>
          <p>Stream</p>
        </div>

        <div className="sidebar__voiceIcons">
          <InfoOutlinedIcon />
          <CallIcon />
        </div>
      </div>

      <div className="sidebar__profile">
        <Avatar className="sidebar__profileAvatar" src={user.photo} />
        <div className="sidebar__profileInfo">
          <h3>{user.displayName}</h3>
          <p>#{user.uid.substring(0, 5)}</p>
        </div>

        <div className="sidebar__profileIcons">
          <ExitToAppIcon
            className="sidebar__signOut"
            fontSize="large"
            onClick={() => signOut(user.demo)}
          />
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
